// Template268: Pekín - Día 2 p.1 (Dia2Pekin.jsx)
// Hero Palacio de Verano + sticker, intro, caja amarilla entradas/horario, Calle Suzhou, Lago Kunming (2 SabiasQue + tip + sticker).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template268 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const yellowBoxP1 = page?.texts?.[3]?.content;
	const yellowBoxP2 = page?.texts?.[4]?.content;
	const title1 = page?.texts?.[5]?.content;
	const body1 = page?.texts?.[6]?.content;
	const title2 = page?.texts?.[7]?.content;
	const body2 = page?.texts?.[8]?.content;
	const tipBlock2 = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const stickerBlock2 = getImageSrc("sticker-block2");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontSize: isSmallScreen ? 28 : 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
					{portadaSticker && (
						<img
							src={portadaSticker}
							alt="sticker"
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: isSmallScreen ? 60 : -10,
								right: isSmallScreen ? "auto" : 0,
								left: isSmallScreen ? 25 : "auto",
							}}
						/>
					)}
				</Box>
			)}

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					{/* Caja amarilla entradas y horario */}
					{(yellowBoxP1 || yellowBoxP2) && (
						<Box
							data-block-id="text-3"
							sx={{
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "12px",
								padding: "10px 14px",
								fontSize: 13,
								color: "#333",
							}}
						>
							{yellowBoxP1 && (
								<Box component="p" sx={estiloP}>
									{yellowBoxP1}
								</Box>
							)}
							{yellowBoxP2 && (
								<Box
									component="p"
									sx={{ ...estiloP, marginTop: 0.75, marginBottom: 0 }}
								>
									{yellowBoxP2}
								</Box>
							)}
						</Box>
					)}

					{/* Block 1: Calle Suzhou */}
					{title1 && (
						<Box
							data-block-id="text-4"
							sx={{
								display: "flex",
								gap: 2,
								position: "relative",
								marginTop: isSmallScreen ? 1 : 0,
							}}
						>
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								<Box component="h3" sx={estiloH3}>
									{title1}
								</Box>
								{body1 && (
									<Box component="p" sx={estiloP}>
										{body1}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Block 2: Lago Kunming - 2 SabiasQue abajo derecha, tip, sticker */}
					{title2 && (
						<Box
							data-block-id="text-5"
							sx={{
								display: "flex",
								gap: 2,
								position: "relative",
								marginBottom: isSmallScreen ? 10 : 0,
							}}
						>
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								<Box component="h3" sx={estiloH3}>
									{title2}
								</Box>
								{body2 && (
									<Box
										component="p"
										sx={estiloP}
										dangerouslySetInnerHTML={{ __html: body2 }}
									/>
								)}
							</Box>
							{sabiasQue[1] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -35 : -10,
										right: isSmallScreen ? "30%" : "25%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							{sabiasQue[2] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -35 : -10,
										right: isSmallScreen ? "45%" : "35%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							{tipBlock2 && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -100 : -60,
										left: 50,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: 320,
										zIndex: 3,
									}}
									dangerouslySetInnerHTML={{ __html: tipBlock2 }}
								/>
							)}
							{stickerBlock2 && (
								<img
									src={stickerBlock2}
									alt="sticker"
									style={{
										width: 105,
										position: "absolute",
										bottom: isSmallScreen ? -120 : -70,
										left: -40,
									}}
								/>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template268.thumbnail = "/images/template-1.png";
export default Template268;
